export const MaxCardSelection = {
  topic: 3,
  unit: 1,
  activities: 30,
};
